module.exports = __webpack_public_path__ + "img/icon-binding.9b53c56b.svg";